<template>
  <div
    class="tkc_upload"
    :class="['tkc_upload_' + size, { tkc_upload_disabled: disabled }]"
    @click="clickUploadHandler"
  >
    <div class="tkc_upload_icon">
      <svg class="cusicon-plus" aria-hidden="true">
        <use xlink:href="#cusicon-plus" />
      </svg>
    </div>
    <div v-if="size == 'large'" class="tkc_upload_label">{{ label }}</div>
  </div>
</template>

<script>
  import vueUtils from '../../../utils/vue_utils';
  export default {
    name: 'UploadComponent',
    props: {
      disabled: Boolean,
      label: {
        type: String,
        default: '点击添加图片',
      },
      size: {
        type: String,
        default: 'normal',
        validator(value) {
          return vueUtils.oneOf(value, ['mini', 'normal', 'large']);
        },
      },
    },
    methods: {
      clickUploadHandler() {
        if (this.disabled) return;
        this.$emit('upload');
      },
    },
  };
</script>

<style lang="less">
  @import '../../../themes';

  .tkc_upload {
    box-sizing: border-box;
    width: 78px;
    height: 78px;
    border: 1px dashed #ccc;
    line-height: 76px;
    color: #666;
    cursor: pointer;
    text-align: center;
    overflow: hidden;
  }

  .tkc_upload:hover {
    border-color: @primary-color;
    color: @primary-color;
    .tkc_upload_icon {
      color: @primary-color;
    }
  }

  .tkc_upload_disabled {
    cursor: not-allowed;
    &:after {
      background-color: #f7f7f7;
    }
  }

  .tkc_upload_disabled:hover {
    border-color: #ccc;
  }

  .tkc_upload_icon {
    display: inline-block;
    width: 32px;
    height: 35px;
    vertical-align: middle;
    position: relative;

    .cusicon-plus {
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      fill: currentColor;
      overflow: hidden;
    }
  }

  .tkc_upload_disabled:hover .tkc_upload_icon {
    .cusicon-plus {
      color: #666;
    }
  }

  .tkc_upload_large {
    width: auto;
    float: none !important;
  }

  .tkc_upload_large .tkc_upload_icon {
    width: 25px;
    height: 25px;
  }

  .tkc_upload_large:hover .tkc_upload_icon {
    color: @primary-color;
  }

  .tkc_upload_label {
    display: none;
  }

  .tkc_upload_large .tkc_upload_label {
    display: inline-block;
    height: 32px;
    margin-left: 10px;
    line-height: 32px;
    font-size: 13px;
    vertical-align: middle;
  }

  .tkc_upload_mini {
    width: 100%;
    height: 100%;
    line-height: 0;
  }

  .tkc_upload_mini .tkc_upload_icon {
    width: 100%;
    height: 100%;
    .cusicon-plus {
      color: #666;
    }
  }

  .tkc_upload_mini:hover .tkc_upload_icon {
    .cusicon-plus {
      color: @primary-color;
    }
  }
</style>
